'use client'

import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  :root {
      --max-width: 1100px;
      --font-mono: ui-monospace, Menlo, Monaco, 'Cascadia Mono', 'Segoe UI Mono',
  }

  html,
  body {
    height: 100vh;
  }

	body.moiraEngineGlobalStyle {
    .moiraClient {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      -webkit-box-pack: justify;
      justify-content: space-between;
      background-color: var(--app-background-desktop);
      position: relative;
    }

    * {
      box-sizing: border-box;
      font-family: var(--typography-type-primary);
      font-display: swap;
      -webkit-overflow-scrolling: touch;
    }

    button {
      outline: none;
      font-family: var(--typography-type-primary);
    }


    a {
      text-decoration: none;
    }

    input {
      outline: none;
      font-family: var(--typography-type-primary);
    }

    textarea {
      outline: none;
      font-family: var(--typography-type-primary);
    }

    select {
      outline: none;
      font-family: var(--typography-type-primary);
    }

    sub {
      font-size: 0.8em;
    }

    sup {
      font-size: 0.8em;
    }

    sub {
      bottom: -0.2em;
    }

    sup {
      top: -0.2em;
    }

    b {
      font-weight: var(--typography-weight-bold);
    }

    em {
      font-weight: var(--typography-weight-bold);
    }

    hr {
      border: none;
      border-top: 1px solid var(--color-disabled);
      clear: both;
      margin-bottom: 1.25rem;
    }

    code {
      font-family: var(--typography-type-code);
      font-size: var(--typography-size-s1);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    pre {
      font-family: var(--typography-type-code);
      font-size: var(--typography-size-s1);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    code {
      display: inline-block;
      padding-left: 2px;
      padding-right: 2px;
      vertical-align: baseline;
      color: var(--color-black2);
    }

    pre {
      line-height: 18px;
      padding: 11px 1rem;
      white-space: pre-wrap;
      background: rgba(0, 0, 0, 0.05);
      color: var(--color-black2);
      border-radius: 3px;
      margin: 1rem 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
      font-family: var(--typography-type-primary);
    }

    p {
      margin: 0;
    }

    .ant-btn {
      border-radius: 12px;
    }

    .ant-btn-primary:not(.ant-btn-disabled,
      [disabled],
      .ant-btn-background-ghost) {
      background-color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .ant-btn-background-ghost:not(:disabled):hover {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .ant-btn-primary.ant-btn-background-ghost {
      color: var(--color-primary);
      background-color: transparent;
      border-color: var(--color-primary);
      box-shadow: none;
    }

    .ant-btn-default:not(:disabled):hover {
      color: var(--color-primary-hover);
      border-color: var(--color-primary-hover);
    }

    .ant-btn-dashed:not(:disabled):hover {
      color: var(--color-primary-hover);
      border-color: var(--color-primary-hover);
    }

    .ant-btn-primary:hover:not(.ant-btn-disabled, [disabled]) {
      background-color: var(--color-primary-hover);
      color: var(--color-white);
    }

    .ant-btn-primary:focus:not(.ant-btn-disabled, [disabled]) {
      background-color: var(--color-primary-hover);
      color: var(--color-white);
    }

    .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
      background-color: var(--color-primary-hover);
      color: var(--color-white);
    }

    .ant-input-number-input,
    .ant-picker {
      height: var(--spacing-height-xlarge);
      border-radius: var(--spacing-borderRadius-small);
      border: 1px solid var(--color-disabled);
      width: 100%;
    }

    .ant-input-affix-wrapper {
      height: var(--spacing-height-xlarge);
      border-radius: var(--spacing-borderRadius-small);
      border: 1px solid var(--color-disabled);
    }

    .ant-input-affix-wrapper:hover {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    .ant-input-affix-wrapper:focus {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    .ant-input-textarea-affix-wrapper {
      height: auto;
    }

    .ant-picker-input {
      flex-direction: row-reverse;
    }

    .ant-picker-input .ant-picker-suffix {
      margin-left: 0;
      margin-right: 4px;
    }

    .ant-form-item-control-input-content:focus,
    .ant-input-affix-wrapper:focus,
    .ant-input-affix-wrapper-focused,
    .ant-picker:hover,
    .ant-picker-focused {
      border-color: var(--color-primary-hover);
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px var(--color-primary-opacity-ten);
    }

    .ant-select-selector {
      height: var(--spacing-height-xlarge);
      border-radius: var(--spacing-borderRadius-small);
    }

    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border-color: var(--color-primary);
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: var(--color-primary-opacity-ten);
    }

    .ant-input {
      border-radius: var(--spacing-borderRadius-small);
      font-size: var(--typography-size-s3);
    }

    .ant-input::placeholder {
      color: var(--color-black2) !important;
      opacity: 1;
    }

    .ant-input:hover {
      border-color: var(--color-primary-hover);
      border-right-width: 1px !important;
    }

    .ant-input:focus {
      border-color: var(--color-primary-hover);
      border-right-width: 1px !important;
    }

    .google-maps-autocomplete-input {
      height: var(--spacing-height-xlarge);
    }

    .ant-select-selection-search {
      display: flex;
      align-items: center;
    }

    .ant-select {
      height: var(--spacing-height-xlarge);
      border-radius: var(--spacing-borderRadius-small);
    }

    .ant-select .ant-select-arrow svg {
      color: var(--color-black1);
    }

    .ant-select:hover .ant-select-selector {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    .ant-select:focus .ant-select-selector {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    /* .ant-select.ant-select-single .ant-select-selector {
      box-shadow: 0 0 0 2px var(--color-primary-opacity-ten) !important;
    } */

    .ant-select .ant-select-selector {
      height: var(--spacing-height-xlarge) !important;
      border-radius: var(--spacing-borderRadius-small) !important;
    }

    .ant-select .ant-select-selection-item,
    .ant-select .ant-select-selection-placeholder {
      display: inline-flex;
      align-items: center;
    }

    .ant-checkbox-wrapper {
      align-items: flex-start;
      grid-template-columns: calc(25.6px) 1fr !important;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner {
      border-color: var(--color-primary);
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
      background-color: var(--color-primary);
    }

    .ant-checkbox-wrapper .ant-checkbox {
      border-color: var(--color-primary);
    }

    .ant-checkbox-wrapper .ant-checkbox:hover::after {
      visibility: hidden !important;
    }

    .ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {
      background-color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner:hover {
      background-color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .ant-checkbox-wrapper .ant-checkbox-inner {
      width: calc(25.6px);
      height: calc(25.6px);
      border-radius: var(--spacing-borderRadius-xSmall) !important;
    }

    .ant-checkbox-wrapper .ant-checkbox-inner::after {
      width: calc(10.67px);
      height: calc(16.61px);
      -moz-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      top: 1px;
      left: 6px;
    }

    .category-level-2:hover {
      background-color: transparent;
    }

    .category-level-2.ant-menu-submenu:hover>.ant-menu-submenu-title {
      &:hover {
        background-color: var(--color-primary-opacity-ten) !important;
      }
    }

    .category-level-2:hover {
      cursor: pointer;
    }

    .category-level-2 .ant-menu-item-group-title {
      color: #000000;
    }

    .subTitle-button:hover {
      background-color: var(--color-primary-opacity-ten) !important;
    }

    .subTitle-button .ant-menu-title-content>button {
      color: var(--color-primary);
    }

    .category-level-3 {
      color: #000000;

      &:hover {
        color: #000000;
        background-color: var(--color-primary-opacity-ten) !important;
      }
    }

    .ant-menu-item.ant-menu-item-only-child.subTitle-button {
      margin: 0px;
      color: #000000;
      background-color: transparent;

      &:hover {
        background-color: var(--color-primary-opacity-ten) !important;
        color: var(--color-primary) !important;
      }
    }

    .ant-menu-item.ant-menu-item-only-child.category-level-2:hover {
      background-color: var(--color-primary-opacity-ten) !important;
    }

    .category-level-2 .ant-menu-title-content {
      color: #000000;

      &:hover {
        cursor: pointer;
        color: #000000;
        font-weight: 600;
      }
    }

    .category-level-2.ant-menu-item-selected {
      background-color: transparent;
    }

    .category-level-3.ant-menu-item-selected {
      background-color: transparent;
    }

    .ant-menu-submenu.submenuCategory>ul.ant-menu {
      border-radius: 8px;
      left: 300px;
      padding: 20px 0px 20px 20px;
      border-right: 5px solid #ffffff;
      max-height: min(50vh, 500px);
    }

    .ant-menu-submenu.ant-menu-light {
      min-width: 300px;
      max-width: 440px;
    }

    .ant-menu::before {
      content: none;
    }

  }
`

export default GlobalStyles
